import React, {Component, ReactNode} from 'react';
import {reportError} from '../helpers/error';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: string;
}

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: string) => void;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }



  componentDidCatch(error: Error, errorInfo: any) {
    this.setState({
      error,
      errorInfo: errorInfo.componentStack
    });

    // 上报错误
    reportError(error, errorInfo.componentStack);

    if (this.props.onError) {
      this.props.onError(error, errorInfo.componentStack);
    }

    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={{
          padding: '20px',
          border: '1px solid #ff6b6b',
          borderRadius: '4px',
          backgroundColor: '#fff5f5',
          color: '#d63031',
          margin: '10px 0'
        }}>
          <h3 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>组件加载失败</h3>
          <details style={{ fontSize: '12px' }}>
            <summary style={{ cursor: 'pointer', marginBottom: '5px' }}>查看错误详情</summary>
            <pre style={{ 
              background: '#f8f9fa', 
              padding: '8px', 
              borderRadius: '2px',
              overflow: 'auto',
              fontSize: '11px'
            }}>
              {this.state.error?.message}
              {this.state.errorInfo}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;